document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tabs-section-wrapper").forEach((section) => {
    let buttons = section.querySelectorAll(".tab-button");
    let contents = section.querySelectorAll(".tab-content");

    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        let targetId = this.getAttribute("data-target");
        contents.forEach((content) => content.classList.remove("active"));
        buttons.forEach((btn) => btn.classList.remove("active"));
        section.querySelector(`#${targetId}`).classList.add("active");
        this.classList.add("active");
      });
    });
  });
});
